import { isImage, type TImageProps } from "@/ui/components/primitives/Image";

import type { TCalloutAsset } from "./Callout.config";

export const isCalloutAssetImage = (
  asset: TCalloutAsset,
): asset is TImageProps => isImage(asset);
